/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const sun = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.924 1v1.166m5.026.884-.825.825M15 8.075h-1.166m-.884 4.875-.825-.825M7.925 15v-1.166M3.05 12.95l.825-.825M1 8.075h1.166M3.05 3.05l.825.825m4.039 7.248a3.037 3.037 0 1 0 0-6.074 3.037 3.037 0 0 0 0 6.074Z"
    />
  </svg>
)
export default sun
